import styled from '@emotion/styled';
import { Button, Typography } from '@ui-components/neo.tax';

export const ButtonSpanTwoColumns = styled(Button)({
  gridColumn: 'span 2',
});

export const ProjectDisallowancesSubHeader = styled(Typography)({
  position: 'relative',
  width: 'fit-content',
});
